export enum FirstPaymentEnum {
  MBWAY = 'MBWAY',
  PENDING = 'PENDING',
  EMPTY = ''
}
